module.exports = __webpack_public_path__ + "img/t4-17.34ca2f6e.svg";